<wr-base-dialog status="info"
                [header]="title"
                submitText="Senden"
                [disableSubmit]="!isFormValid()"
                [submitResponse]="submitResponse.bind(this)"
                dialogWidth="giant">
  @if (form) {
    <form [formGroup]="form">
      <hau-form-field label="Betreff" [validation]="form.validation.subject">
        <input type="text" formControlName="subject" nbInput fullWidth>
      </hau-form-field>
      <hau-form-field label="Empfänger" [validation]="form.validation.recipients">
        <wr-select-recipient formControlName="recipients" inputName="recipients" autocomplete="section-recipients email"
                             [presetSuggestions]="recipientSuggestions">
        </wr-select-recipient>
      </hau-form-field>
      <hau-form-field label="CC" [validation]="form.validation.cc">
        <wr-select-recipient formControlName="cc" inputName="cc" autocomplete="section-cc email"></wr-select-recipient>
      </hau-form-field>

      <hau-form-field>
        <nb-checkbox formControlName="sendCopyToSender">
          Kopie der E-Mail an Versender senden
        </nb-checkbox>
      </hau-form-field>


      <hau-form-field label="Text" [validation]="form.validation.body">
        <wr-rich-text-editor formControlName="body"></wr-rich-text-editor>
      </hau-form-field>

      @if (allowAttachments) {
        <hau-form-field label="Anhänge" [validation]="form.validation.userAttachments">
          <wr-multi-attachment-control formControlName="userAttachments"></wr-multi-attachment-control>
        </hau-form-field>
      }
    </form>
  }
  {{ message }}
</wr-base-dialog>
